import { mapActions, mapState } from 'vuex';
import { debounce } from 'lodash';
import formCheckbox from '@/components/forms/checkbox/checkbox.vue';
import currencyInput from '@/components/forms/currency-input/currency-input.vue';
import loaderMixin from '@/mixins/loader';

const DEBOUNCE_TIME = 1000;

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    formCheckbox,
    currencyInput,
  },
  props: {
    category: {
      type: String,
      required: true,
    },
    obj: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
      errorChecked: null,
      value: this.initialValue,
      errorValue: null,
      debounceUpdate: null,
    };
  },
  computed: {
    ...mapState('profile', ['settings']),
    name() {
      return this.obj.key;
    },
    checkboxName() {
      return `${this.category}${this.name}`;
    },
    withValue() {
      return this.obj.withValue;
    },
    getSettingsChecked() {
      return this.settings[this.category][this.name];
    },
    getSettingsValue() {
      return this.withValue ? this.settings[this.category][this.withValue] : 0;
    },
    classObject() {
      return {
        'check-option': true,
        'check-option--with-value': this.withValue,
        'check-option--disabled': this.disabled,
      };
    },
    initialValue() {
      return 10;
    },
  },
  methods: {
    ...mapActions('profile', ['updateSettings']),
  },
  created() {
    this.checked = this.getSettingsChecked;
    const parsed = Number.parseInt(this.getSettingsValue, 10);
    this.value = Number.isNaN(parsed) ? this.initialValue : parsed;

    this.$watch('checked', (val, old) => {
      if (this.errorChecked !== val) {
        this.loaderAdd();
        this.updateSettings({
          category: this.category,
          key: this.name,
          value: val,
        })
        .then(() => this.loaderRemove())
        .catch(() => {
          this.loaderRemove();
          this.errorChecked = old;
          this.checked = this.errorChecked;
          this.$emit('error', `Could not set "${this.obj.info}"`);
        });
      } else {
        this.errorChecked = null;
      }
    });

    this.debounceUpdate = debounce((val) => {
      this.updateSettings({
        category: this.category,
        key: this.withValue,
        value: val,
      }).catch(() => {
        this.errorValue = this.getSettingsValue;
        this.value = this.errorValue;
        this.$emit('error', `Could not set "${this.obj.info}"`);
      });
    }, DEBOUNCE_TIME, { trailing: true });

    if (this.withValue) {
      this.$watch('value', (val) => {
        // prevents watch endless loop
        if (this.errorValue !== val) {
          this.debounceUpdate(val);
        } else {
          this.errorValue = null;
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/account/settings/check-option/check-option.js